import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import InputtableDropdown from './dropdown-types/inputtable-dropdown.jsx';
import LabelDropdown from './dropdown-types/label-dropdown.jsx';
import ButtonDropdown from './dropdown-types/button-dropdown.jsx';
import DropdownContainer from './dropdown-container';

export default class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.goToSelectedItem = this.goToSelectedItem.bind(this);
    this.closeDropdownOnBlur = this.closeDropdownOnBlur.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.persistOpenOnBlur = false;

    this.state = {open: false};
  }

  componentDidMount() {
    this.currentDropdown = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
  }

  componentWillUnmount() {
    this.removeBlurListeners();
  }

  componentWillReceiveProps(props) {
    this.persistOpenOnBlur = Boolean(props.persistOpenOnBlur);
  }

  closeDropdownOnBlur(ev) {
    if (this.state.open && !this.currentDropdown.contains(ev.target)) {
      this.closeDropdown();
    }
  }

  onChangeHandler(ev) {
    this.props.changeHandler(ev);

    this.closeDropdown();
  }

  goToSelectedItem() {
    if (_.isEmpty(this.currentDropdown)) {
      return false;
    }

    const dropdownList = _.first(this.currentDropdown
      .querySelectorAll('.dropdown-drop'));

    const selectedItem = _.first(this.currentDropdown
      .querySelectorAll('.dropdown-highlighted'));

    if ( !_.isEmpty(selectedItem) ) {
      dropdownList.scrollTop = selectedItem.offsetTop;
    }
  }

  addOnBlurListeners() {
    document.addEventListener('click', this.closeDropdownOnBlur, true);
    document.addEventListener('keydown', this.closeDropdownOnBlur, true);
  }

  removeBlurListeners() {
    document.removeEventListener('click', this.closeDropdownOnBlur, true);
    document.removeEventListener('keydown', this.closeDropdownOnBlur, true);
  }

  openDropdown() {
    this.setState({open: true}, () => {
      this.goToSelectedItem();
      this.addOnBlurListeners();
    });
  }

  closeDropdown() {
    if (this.persistOpenOnBlur) {
      return;
    }

    this.setState({open: false}, this.removeBlurListeners);
  }

  setDropdownState(open) {
    if (open) {
      this.openDropdown();
    } else {
      this.closeDropdown();
    }
  }

  toggleDropdown() {
    this.setDropdownState(!this.state.open);
  }

  render() {
    let dropdown = (
      <LabelDropdown
        open={this.state.open}
        label={this.props.label}
        changeHandler={this.onChangeHandler}
        options={this.props.options}
        toggleDropdown={this.toggleDropdown}
        selectedLabelStyle={this.props.selectedLabelStyle}
      />
    );

    if (this.props.type === "input") {
      dropdown = (
        <InputtableDropdown
          open={this.state.open}
          value={this.props.value}
          options={this.props.options}
          changeHandler={this.onChangeHandler}
          toggleDropdown={this.toggleDropdown}
        />
      );
    } else if (this.props.type === 'button') {
      dropdown = (
        <ButtonDropdown
          open={this.state.open}
          label={this.props.label}
          toggleDropdown={this.toggleDropdown}
          selectedLabelStyle={this.props.selectedLabelStyle}
          buttonClickHandler={this.props.buttonClickHandler}
          buttonClassName={this.props.buttonClassName}
          buttonText={this.props.buttonText}
          allowTopScroll={this.props.allowTopScroll}
          options={this.props.options}
          changeHandler={this.onChangeHandler}
          collapsibleOptions={this.props.collapsibleOptions}
          wide={this.props.wide}
          openRight={this.props.openRight}
        />
      );
    }

    return (
      <DropdownContainer
        disabled={this.props.disabled}
        className={this.props.className}
        open={this.state.open}
        wide={this.props.wide}
        openRight={this.props.openRight}
      >
        {dropdown}
      </DropdownContainer>);
  }
}

Dropdown.propTypes = {
  className: React.PropTypes.string,
  persistOpenOnBlur: React.PropTypes.bool,
  label: React.PropTypes.string,
  value: React.PropTypes.string,
  type: React.PropTypes.string,
  selectedLabelStyle: React.PropTypes.object,
  changeHandler: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  options: React.PropTypes.array,
  collapsibleOptions: React.PropTypes.array,
  buttonClickHandler: React.PropTypes.func,
  buttonClassName: React.PropTypes.string,
  buttonText: React.PropTypes.string,
  allowTopScroll: React.PropTypes.bool,
  wide: React.PropTypes.bool,
  openRight: React.PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown.jsx